export default __webpack_public_path__ + "images/badbc37f799820567de5b50b96d08c29-inv-smart-deal.svg";